import { useMutation } from "@tanstack/react-query";
import SummaryInvoiceDataService from "services/SummaryInvoiceDataService";

export const useDetailReport = (onSuccess, onError) => {
  const mutate = useMutation(SummaryInvoiceDataService.detailReport, {
    retry: 0,
    onSuccess: data => {
      if (typeof onSuccess === "function") {
        //   onSuccess({ ...data, appCodes });
      }
    },
    onError: error => {
      if (typeof onError === "function") {
        //   onError(errorResponse);
      }
    },
  });
  return mutate;
};
